import CTNEllipsis from '@ctn/ui/components/ctn-ellipsis';
import { CTNIcon, CTNIconTooltip } from '@ctn/ui/components/ctn-icon';
import { type CTNIconProps, type CTNIconTooltipProps } from '@ctn/ui/types/ctn-icon';
import classNames from 'classnames';
import React from 'react';

type TextIconProps = {
	readonly className?: string;
	readonly description?: string;
	readonly iconRight?: CTNIconProps | CTNIconTooltipProps;
	readonly iconLeft?: CTNIconProps | CTNIconTooltipProps;
	readonly isFit?: boolean;
	readonly tag?: keyof React.JSX.IntrinsicElements;
};

const classNameComponent = 'c-pnp-text-icon';

export default function TextIcon({ className, description, iconRight, isFit, iconLeft, tag: Tag = 'span' }: TextIconProps) {
	const classNameTextIcon = classNames(classNameComponent, className, { [`${classNameComponent}--fit`]: isFit });

	const getIcon = (icon: CTNIconProps | CTNIconTooltipProps) =>
		'tooltip' in icon ? <CTNIconTooltip {...icon} /> : <CTNIcon {...icon} />;

	const IconLeft = iconLeft ? getIcon(iconLeft) : null;

	const IconRight = iconRight ? getIcon(iconRight) : null;

	return (
		<span className={classNameTextIcon}>
			{IconLeft}
			{description && (
				<Tag className={`${classNameComponent}__txt`}>
					<CTNEllipsis content={description} />
				</Tag>
			)}
			{IconRight}
		</span>
	);
}
